<template>
  <div class="formRadio">
    <div class="body">
      <form-label :label="label" :required="isRequired" />
      <div class="radioArea">
        <div v-for="(option, idx) of options" :key="idx" class="wrap">
          <input
            :id="`${name}${idx}`"
            type="radio"
            :name="name"
            :value="option.value"
            :checked="checked === option.value"
            @change="update($event)"
          />
          <label :for="`${name}${idx}`">{{ option.text }}</label>
        </div>
      </div>
    </div>
    <!-- <div class="footer">
      <p class="errorMessage">{{}}</p>
    </div> -->
  </div>
</template>

<script>
import FormLabel from './FormLabel'

export default {
  name: 'FormRadio',
  components: {
    FormLabel,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    defaultNoCheck: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checked() {
      return !this.value && !this.defaultNoCheck
        ? this.options[0].value
        : this.value
    },
  },
  methods: {
    update($event) {
      if ($event) {
        this.$emit('input', $event.target.value)
        this.$emit('change', $event.target.value)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.formRadio {
  margin-bottom: 20px;
  .radioArea {
    display: flex;
    .wrap {
      display: flex;
      align-items: center;
    }
    input[type='radio'] {
      display: none;
    }
    label {
      position: relative;
      padding-left: 30px;
      margin-right: 20px;
      font-size: 14px;
      line-height: 22px;
      cursor: pointer;
    }
    label::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border: 1px solid #DCDFE2;
      border-radius: 50%;
    }
    input[type='radio']:checked + label::after {
      content: '';
      display: block;
      position: absolute;
      top: 4px;
      left: 4px;
      width: 12px;
      height: 12px;
      background: #FF4438;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/FormRadio.vue